 import React from "react";
import ComponentResultsWithIMG from "../ComponentResultsWithIMG/ComponentResultsWithIMG";
import {GET_ALL_CONTEST_RESULTS_SMALL} from "../../../../../../AdminPart/GraphQL/queries/OnlyHereQueries";
import {useQuery} from "@apollo/client";

function QueryContestResultsWithIMGSource (props) {
    const { loading, error, data} = useQuery(GET_ALL_CONTEST_RESULTS_SMALL);
    if (loading) return 'loading...';
    if (error) return `loading error! ${error.message}`;

    function ContestResultToFormatWeNeed(AllContestResult) {
        try {
            return AllContestResult.map(function (contest) {
                const ContestName = contest.ContestName.split('---');
                return {id: contest._id, ContestName: ContestName[0], ContestDate: contest.ContestDate, ContestWin : ContestName[1]};
            });
        }  catch(error) {console.error(error);}

    }
    const ArrayForSort = [...data.getAllContestResults];
    const AllContestResults = ContestResultToFormatWeNeed(ArrayForSort.sort((a, b) => {if (b.ContestDate < a.ContestDate) {return -1} else {return 1}})); // Берем из базы элемент, обрабатываем в нужный формат. Превращаем в массив объектов.
    if (AllContestResults.length !==0) {
        return <ComponentResultsWithIMG AllResults={AllContestResults} lang={props.lang} data={props.data} />;
    } else {
        return <div/>
    }}
export default QueryContestResultsWithIMGSource